export const POLL_BY_ID = "poll-by-id";
